import React from 'react'

import { useTranslation } from 'react-i18next'

import { StringText } from '@/Atomic/Atoms/StringText'

interface CountItemProps {
  count: number
  isFolder: boolean
}

export const CountItem: React.FC<CountItemProps> = ({ isFolder, count }) => {
  const { t } = useTranslation()
  const text = isFolder
    ? t('components.document.folders')
    : t('components.document.files')

  return (
    <li className="count-item">
      <StringText variant="title" value={text} />
      &nbsp;
      <StringText variant="subtitle" value={`(${count})`} />
    </li>
  )
}
